import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { deleteProviderFailed, deleteProviderSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* deleteProvider(action) {
  try {
    const url = `${BACKEND_URL}/providers/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'DELETE', true);
    if (dataResponse.status === OK) {
      yield put(deleteProviderSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(deleteProviderFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(deleteProviderFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
